// useNotificationData.js - 获取通知数据的Hook（简化版本，使用 Context）

import { useNotifications } from '../../../context/NotificationContext';

/**
 * 🔧 【性能优化】使用统一的 NotificationContext
 * 不再独立加载通知数据，直接从 Context 获取
 */
const useNotificationData = () => {
  const context = useNotifications();

  // 为了保持向后兼容，将 fetchNotifications 映射为 loadNotifications
  return {
    notifications: context.notifications,
    isLoading: context.isLoading,
    error: context.error,
    unreadCount: context.unreadCount,
    fetchNotifications: context.loadNotifications, // 映射函数名以保持兼容
    markAsRead: context.markAsRead,
    markAllAsRead: context.markAllAsRead,
  };
};

export default useNotificationData;
